module.exports = __webpack_public_path__ + "img/christmas_sausage.4d9bfd6e.png";